import { notFound } from 'next/navigation';

import type { IProductOptions } from '@/entities/product/types';
import type { ISlotItem } from '@/entities/slot/types';
import { utilDateFormat } from '@/lib/date';
import { NEXT_PUBLIC_API_URL } from '@/lib/env';
import { utilFetch } from '@/lib/utils';

interface IParams extends IProductOptions {
  date?: Date | null;
}
const apiGetSlot = async ({ idx, lng, date }: IParams): Promise<ISlotItem> => {
  const response = await utilFetch(lng)(
    `${NEXT_PUBLIC_API_URL}/api/slot/${idx}${date ? `?date=${utilDateFormat(date, 'YYYY-MM-DD')}` : ''}`,
    {
      method: 'GET',
    },
  );
  const result = await response.json();

  // error handling
  if (!result.ok) {
    notFound();
  }

  return filterSlot(result.data);
};

export default apiGetSlot;

const filterSlot = (response: any): ISlotItem => {
  return {
    idx: response.idx,
    type: 'SLOT',
    title: response.title,
    description: response.description,
    descriptionGoto: response?.descriptionGoto || '',
    included: response?.included || '',
    excluded: response?.excluded || '',
    date: new Date(response.date),
    isActive: response.isActive,
    slotOptionTitle: response?.slotBoxesTitle || '',
    slotOptionList: response.slotBoxes.map((slotOption: any) => {
      return {
        idx: slotOption.idx,
        title: slotOption.title,
        price: slotOption.price,
        type: slotOption.type,
        maxCount: slotOption.maxCount,
        availableCount: slotOption.availableCount,
        isActive: slotOption.isActive,
      };
    }),
    optionGroupList: response.optionGroups.map((optionGroup: any) => ({
      idx: optionGroup.idx,
      title: optionGroup.title,
      description: optionGroup?.description || '',
      isMultiSelect: optionGroup.isMultiSelect,
      isActive: optionGroup.isActive,
      isRequired: optionGroup?.isRequired,
      optionList: optionGroup.options.map((option: any) => ({
        idx: option.idx,
        title: option.title,
        price: option.price,
        isActive: option.isActive,
      })),
    })),
  };
};
